/**
 * On tab press close any previously open tabs
 */
const tabs = $('.s-tabs__tab');

/**
 * Only run this code if the page has tabs
 */
if (tabs.length > 0) {
    // delay loading script until the document is fully ready
    document.onreadystatechange = function () {
        // The document and all sub-resources have finished loading. The state indicates that the load event is about to fire
        if (document.readyState === 'complete') {
            positionItems();
        }
    };

    // load the script on screen resize
    window.onresize = function () {
        positionItems();
    };
}

/**
 * Position expandable items in the right place
 */

$(document).ready(function() {
    setTimeout(function () {
        $(window).trigger('resize');

    }, 3000);
});


var previousScreenSize = 'mobile';
function positionItems() {
    // variables
    var items = $('.s-tabs .c-list-expandable__item');
    var itemsInner = $('.s-tabs .c-list-expandable__inner');
    var itemsWrap = $('.s-tabs .c-list-expandable');
    var divisionToggle = $('.s-tabs .division-toggle button');

    if (window.innerWidth >= 768) {
        /**
         * Expandable items
         */
        var largestItemHeight = 480;

        // check what is the height of the highest item
        items.each(function () {
            // get current item hight
            var itemHeight = this.scrollHeight;

            // update the largest height variable if the current item
            // is higher than the previous ones
            if (itemHeight > largestItemHeight) {
                largestItemHeight = itemHeight;
            }
        });

        // make the wrapping container as high as the highers item it contains
        itemsWrap.height(largestItemHeight);

        // run this code if the previous screen size was not desktop to prevent
        // running it each time when the screen size has change by a 1 pixel
        if ('desktop' !== previousScreenSize) {
            /**
             * Tabs
             */
            tabs.click(function (e) {
                // prevent the same event from being executed multiple times
                e.stopImmediatePropagation();

                // rest tabs by making them all inactive
                tabs.removeClass('active');

                // make the clicked tab active
                this.classList.add('active');

                // rest all expandable items by removing the class extended and
                items.css('z-index', 0);
                itemsInner.fadeOut(250);
                divisionToggle.removeClass('tcon-transform');

                // find the expandable heading relate to this tab and click on it
                // to show the content and change the plus icon to minus in the heading
                var showItem = $('#' + this.children[0].dataset.expandable);
                showItem.fadeIn(250);
                showItem.parent('.c-list-expandable__item').css('z-index', 1);
                showItem.siblings('.c-list-expandable__title-wrap').find('.tcon').addClass('tcon-transform');
            });

            // rest all expandable items by collapsing all extendable items
            // and changing the 'minus' icons to the 'plus'
            itemsInner.hide();
            divisionToggle.removeClass('tcon-transform');

            // display the fist tab
            tabs.first().click();

            // position all items absolutely
            items.css({
                opacity: 1,
                // position: 'absolute',
                // top: 0,
                // bottom: 0,
                // left: 0,
                // right: 0,
            });

            /**
             * Expandable items
             */
            // avoid doing the same action by remembering
            // what is the size of the current screen
            previousScreenSize = 'desktop';
        }
    } else {
        if ('mobile' !== previousScreenSize) {
            itemsWrap.height('initial');

            // position all items absolutely
            items.css({
                position: 'relative',
            });

            // avoid doing the same action by remembering
            // what is the size of the current screen
            previousScreenSize = 'mobile';
        }
    }
}



// WEBPACK FOOTER //
// ./scripts/routes/sections/tabs.js